var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleBodyType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 14C22.9477 14 22.5 14.4477 22.5 15C22.5 15.5523 22.9477 16 23.5 16H26.5C27.0523 16 27.5 15.5523 27.5 15C27.5 14.4477 27.0523 14 26.5 14H23.5Z",
    fill: "#0052BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 15C5.5 14.4477 5.94772 14 6.5 14H9.5C10.0523 14 10.5 14.4477 10.5 15C10.5 15.5523 10.0523 16 9.5 16H6.5C5.94772 16 5.5 15.5523 5.5 15Z",
    fill: "#0052BE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3423 3.47612L29.1772 9.21023L30.9917 8.13882C31.4673 7.85801 32.0804 8.01589 32.3612 8.49146C32.6421 8.96703 32.4842 9.58019 32.0086 9.861L29.8024 11.1637L29.9767 11.7085C30.3235 12.7922 30.5 13.9232 30.5 15.061V26C30.5 26.5523 30.0523 27 29.5 27H32.5V29H0.5V27H3.5C2.94772 27 2.5 26.5523 2.5 26V15.061C2.5 13.9232 2.67654 12.7922 3.02333 11.7085L3.1977 11.1636L0.991705 9.861C0.516138 9.58019 0.358257 8.96703 0.639068 8.49146C0.919879 8.01589 1.53304 7.85801 2.00861 8.13882L3.82282 9.21007L5.65769 3.47612C6.32038 1.40523 8.24546 0 10.4198 0H22.5802C24.7545 0 26.6796 1.40522 27.3423 3.47612ZM7.56254 4.08568C7.96015 2.84314 9.1152 2 10.4198 2H22.5802C23.8848 2 25.0399 2.84313 25.4375 4.08567L27.33 9.99991H5.66998L7.56254 4.08568ZM5.02998 11.9999H27.97L28.0718 12.318C28.3556 13.2047 28.5 14.13 28.5 15.061V22H24.2207L22.4486 16.6838C22.3125 16.2754 21.9304 16 21.5 16H11.5C11.0695 16 10.6874 16.2754 10.5513 16.6838L8.77919 22H4.5V15.061C4.5 14.13 4.64445 13.2047 4.92818 12.318L5.02998 11.9999ZM10.8874 22H22.1125L20.7792 18H12.2207L10.8874 22ZM27.5 27C26.9477 27 26.5 26.5523 26.5 26V24H6.5V26C6.5 26.5523 6.05228 27 5.5 27H27.5Z",
    fill: "#0052BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleBodyType);
export default __webpack_public_path__ + "static/media/vehicle-body-type.da0ade01df7e70a21408139ae32049d6.svg";
export { ForwardRef as ReactComponent };